import React, { Component } from 'react';
import Dropzone from 'react-dropzone';

class DropzoneComponent extends Component {
  constructor(props) {
    super(props);
    this.dropzoneRef = React.createRef();
  }

  handleDrop = (acceptedFiles) => {
    if (this.props.onFileSelected && acceptedFiles.length > 0) {
      this.props.onFileSelected(acceptedFiles[0]);
    }
  };

  handleManualClick = () => {
    if (this.dropzoneRef.current) {
      this.dropzoneRef.current.open();
    }
  };

  generarAcceptObject = (extensiones) => {
    const mapaMime = {
      zip: 'application/zip',
      pdf: 'application/pdf',
      png: 'image/png',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      xml: 'application/xml',
      jrxml: 'application/xml',
      csv: 'text/csv'
    };

    const accept = {};

    extensiones.forEach((ext) => {
      const mime = mapaMime[ext.toLowerCase()];
      if (mime) {
        if (!accept[mime]) {
          accept[mime] = [];
        }
        accept[mime].push(`.${ext.toLowerCase()}`);
      }
    });

    return accept;
  };


  render() {
    
    const accept = this.generarAcceptObject(this.props.archivos_soportados || []);

    return (
      <Dropzone
        ref={this.dropzoneRef}
        onDrop={this.handleDrop}
        accept={accept}
        multiple={false}
        noClick
        noKeyboard
      >
        {({ getRootProps, getInputProps, open }) => {
          // Backup manual click fallback in case ref doesn't work
          this.dropzoneRef.current = { open };

          return (
            <div {...getRootProps({ className: 'carga-documento-content' })}>
              <div className="icon">
                <span className="material-symbols-outlined">
                  upload
                </span>
              </div>

              <div className="caption">
                <p className="text">
                  Arrastre y suelte aquí el archivo para subirlo
                  <small>O si prefieres..</small>
                </p>
              </div>

              <input {...getInputProps()} />

              <button
                type="button"
                className="local-upload btn-medium btn-primary-outline"
                onClick={this.handleManualClick}
              >
                Seleccionar archivo de tu dispositivo
              </button>

              <p className="text-alert">
                La carga solo soporta archivos en formato {this.props.archivos_soportados?.join(', ')}.
              </p>
            </div>
          );
        }}
      </Dropzone>
    );
  }
}

export default DropzoneComponent;